export const PICKUP_DAYS = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"] as const;
export const PICKUP_TIMES = ["MORNING", "AFTERNOON", "ALLDAY"] as const;

export type PickupDay = (typeof PICKUP_DAYS)[number];
export type PickupTime = (typeof PICKUP_TIMES)[number];
